import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { SystemLog, SystemLogLevel, SystemLogStatusValue, SystemLogsList } from "@/types";

export interface SystemLogsFilters {
  domain?: string;
  level?: SystemLogLevel;
  status?: SystemLogStatusValue;
  search?: string;
  fromDate?: string;
  toDate?: string;
  cursor?: string;
  limit?: number;
}

export function useSystemLogs(filters: SystemLogsFilters = {}) {
  return useQuery({
    queryKey: ["system-logs", filters],
    queryFn: () => {
      const params: Record<string, string> = {
        limit: String(filters.limit ?? 50),
      };
      if (filters.domain) params.domain = filters.domain;
      if (filters.level) params.level = filters.level;
      if (filters.status) params.status = filters.status;
      if (filters.search) params.search = filters.search;
      if (filters.fromDate) params.fromDate = filters.fromDate;
      if (filters.toDate) params.toDate = filters.toDate;
      if (filters.cursor) params.cursor = filters.cursor;
      return api.get<SystemLogsList>("/admin/system-logs", params);
    },
  });
}

export function useSystemLog(id: string | null) {
  return useQuery({
    queryKey: ["system-log", id],
    queryFn: () => api.get<SystemLog>(`/admin/system-logs/${id ?? ""}`),
    enabled: id !== null,
  });
}
